import {
  AfterContentInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DatepickerDayComponent, IDatepickerSchema, ToastService } from "maps-angular-components";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Subject, Subscription } from "rxjs";

import { AssociacaoService } from "../associacao.service";
import { DadosCarteiraRegraModel } from "../dados-carteira-regra.model";
import { ValidacaoSelecaoModel } from "../selecao-carteira/carteira-selecao-model";

@Component({
  selector: "execucao-vigencia",
  templateUrl: "./execucao-vigencia.component.html",
  styleUrls: ["./execucao-vigencia.component.scss"],
})
export class ExecucaoVigenciaComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  form: FormGroup;
  page = 1;
  associacaoListForm: FormGroup;
  validacaoSelecaoModels: ValidacaoSelecaoModel[] = [];
  dataInicioAssociacao;
  @Input() carteiraRegra$: Subject<DadosCarteiraRegraModel>;
  @Output() onDataFilled: EventEmitter<ValidacaoSelecaoModel[]> =
    new EventEmitter<ValidacaoSelecaoModel[]>();

  associacaoEdicao: ValidacaoSelecaoModel;
  associacaoOriginal: ValidacaoSelecaoModel;
  dataEdicao: any;

  @ViewChild("execucaoVigenciaDataInicio", { static: false })
  execucaoVigenciaDataInicio: DatepickerDayComponent;

  public dataInicioAssociacaoSchema: IDatepickerSchema;

  constructor(
    public associacaoService: AssociacaoService,
    private readonly messageService: ToastService
  ) {}

  setModoEdicao(a) {
    this.associacaoOriginal = a ? { ...a } : null;
    this.associacaoEdicao = a ? { ...a } : null;

    this.dataEdicao = a ? this.associacaoOriginal.dataInicioAssociacao?.toISOString().substring(0, 10).split('-').reverse().join('/') : null;
  }

  associacaoIsEqual(a: ValidacaoSelecaoModel, b: ValidacaoSelecaoModel): boolean {
    return a && b
      && a.carteiraId === b.carteiraId
      && a.regraId === b.regraId;
  }

  save() {
    this.dataEdicao = this.dataEdicao?.substring(0, 10);
    const isoDate = this.dataEdicao?.split('/').reverse().join('-') + ' 12:00:00';

    if (!isNaN(Date.parse(isoDate))) {

      this.associacaoEdicao = { ...this.associacaoEdicao, dataInicioAssociacao: new Date(isoDate)};

      this.validacaoSelecaoModels = this.validacaoSelecaoModels.map(a =>
        (this.associacaoIsEqual(a, this.associacaoOriginal)) ? this.associacaoEdicao : a );
    } else {
      this.messageService.alerta(`Data inválida:  ${this.dataEdicao}`)
    }

    this.onDataFilled.emit(this.validacaoSelecaoModels);

    this.setModoEdicao(null);
  }

  marcaAssociacao(value: any) {
    this.dataInicioAssociacao = value.dataInicioAssociacao;

    const associacao = this.validacaoSelecaoModels;
    if (associacao.length === 0) {
      const model = new ValidacaoSelecaoModel();
      associacao.push(model);
    }
    for (const validacaoSelecaoModel of associacao) {

      if (this.dataInicioAssociacao !== null) {
        validacaoSelecaoModel.dataInicioAssociacao = this.dataInicioAssociacao;
        if (this.form.get('processamentoOnlineAtivo').value) {
          validacaoSelecaoModel.processamentoOnlineAtivo = this.form.get('processamentoOnlineAtivo').value;
        }
      }
    }
    this.onDataFilled.emit(this.validacaoSelecaoModels);
  }

  remove(s: ValidacaoSelecaoModel) {
    const associacao = this.validacaoSelecaoModels;
    const index = associacao.findIndex(
      (i) => i.carteiraNome === s.carteiraNome && i.regraNome === s.regraNome
    );
    if (index >= 0) {
      associacao.splice(index, 1);
    }
    this.validacaoSelecaoModels = associacao;
  }

  getAssociacao() {
    return this.getAssociacaoPaginado(this.page);
  }

  getAssociacaoPaginado(page: number) {
    const associacao = this.validacaoSelecaoModels;
    const associacaoPagnating: ValidacaoSelecaoModel[] = [];
    const start = page * 10 - 10;
    for (let i = start; i < page * 10 && i < associacao.length; i++) {
      associacaoPagnating.push(associacao[i]);
    }
    associacaoPagnating.sort(this.compareAssociacao);
    return associacaoPagnating;
  }

  compareAssociacao(a: ValidacaoSelecaoModel, b: ValidacaoSelecaoModel) {
    if (a.carteiraNome < b.carteiraNome) {
      return -1;
    }
    if (a.carteiraNome > b.carteiraNome) {
      return 1;
    }
    if (a.regraNome < b.regraNome) {
      return -1;
    }
    if (a.regraNome > b.regraNome) {
      return 1;
    }
    return 0;
  }

  receiverPage(event) {
    this.page = event;
  }

  markAsPending(): void {
    this.execucaoVigenciaDataInicio.date.markAsPending();
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsPending();
      }
    });
  }

  clear() {
    this.dataInicioAssociacao = null;
    this.validacaoSelecaoModels = [];
    this.onDataFilled.emit([]);

    this.execucaoVigenciaDataInicio.reset();
    this.markAsPending();
    this.form.reset();
  }

  ngOnInit(): void {
    this.dataInicioAssociacao = null;
    this.form = new FormGroup({
      dataInicioAssociacao: new FormControl(Validators.required),
      processamentoOnlineAtivo: new FormControl(false, null, null),
    });

    this.dataInicioAssociacaoSchema = {
      label: "Data início associação",
      placeholder: "Selecione uma data",
      formGroup: this.form,
      formControlName: "dataInicioAssociacao",
      panelClass: 'w-100',
      required: true,
    };

    this.carteiraRegra$.subscribe((dados) => {
      this.validacaoSelecaoModels = [];
      if (dados.regras.length > 0 && dados.carteiras.length === 0) {
        this.popularDadosRegras(dados);
      } else if (dados.carteiras.length > 0 && dados.regras.length === 0) {
        this.popularDadosCarteiras(dados);
      } else {
        this.popularDadosParaCarteiraRegra(dados);
      }
      this.onDataFilled.emit(this.validacaoSelecaoModels);
    });

  }

  private popularDadosParaCarteiraRegra(dados: DadosCarteiraRegraModel) {
    for (const carteira of dados.carteiras) {
      for (const regra of dados.regras) {
        const validacaoSelecaoModel = new ValidacaoSelecaoModel();
        validacaoSelecaoModel.regraNome = regra.nome;
        validacaoSelecaoModel.regraId = +regra.id;
        validacaoSelecaoModel.carteiraNome = carteira.name;
        validacaoSelecaoModel.carteiraId = +carteira.id;
        if (this.dataInicioAssociacao !== null) {
          validacaoSelecaoModel.dataInicioAssociacao = this.dataInicioAssociacao;
        }
        this.validacaoSelecaoModels.push(validacaoSelecaoModel);
      }
    }
  }

  private popularDadosCarteiras(dados: DadosCarteiraRegraModel) {
    for (const carteira of dados.carteiras) {
      const validacaoSelecaoModel = new ValidacaoSelecaoModel();
      validacaoSelecaoModel.carteiraNome = carteira.name;
      validacaoSelecaoModel.carteiraId = +carteira.id;
      if (this.dataInicioAssociacao !== null) {
        validacaoSelecaoModel.dataInicioAssociacao = this.dataInicioAssociacao;
      }
      this.validacaoSelecaoModels.push(validacaoSelecaoModel);
    }
  }

  private popularDadosRegras(dados: DadosCarteiraRegraModel) {
    for (const regra of dados.regras) {
      const validacaoSelecaoModel = new ValidacaoSelecaoModel();
      validacaoSelecaoModel.regraNome = regra.nome;
      validacaoSelecaoModel.regraId = +regra.id;
      if (this.dataInicioAssociacao !== null) {
        validacaoSelecaoModel.dataInicioAssociacao = this.dataInicioAssociacao;
      }
      this.validacaoSelecaoModels.push(validacaoSelecaoModel);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
